export default "__VITE_ASSET__DeT$pRuM__"